module.exports = __webpack_public_path__ + "img/documents--avatar.47b5b543.svg";